// ✅ src/services/tenantService.js
import axiosClient from "../api/axiosClient";

// Super Admin only: list all tenants
export const getTenants = async () => {
  const { data } = await axiosClient.get("/tenant/api/list");
  return data; // { success, data: [ {id,name,...}, ... ] }
};
